// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SimilarImagesIconComponent Styles */
:host {
    --img-similar-images-size: 50px;
    width: var(--img-similar-images-size);
    height: var(--img-similar-images-size);
    aspect-ratio: 1 / 1;
    position: absolute;
    top: 5px;
    left: 5px;
}

.img-similar-images {
    flex-direction: row;
    padding: 3px;
    align-items: center;
    border-radius: var(--radius-extra-small);
    background-color: var(--surface-variant-dark-transparency);
    margin: 3px 0 0 3px;
    width: 100%;
    aspect-ratio: 1 / 1;
}

.img-similar-images:hover {
    cursor: pointer;
    background-color: var(--surface-variant-transparency);
    transition: background-color 0.5s ease-in-out;
}

img {
    object-fit: cover;
}

[data-similar-tooltip-placeholder] {
    --similar-tooltip-size: 40px;
    width: var(--similar-tooltip-size);
    height: var(--similar-tooltip-size);
    aspect-ratio: 1 / 1;
}

[data-similar-tooltip-placeholder]:hover {
    cursor: pointer;
    transform: scale(1.05);
    transition: transform 0.2s ease-in-out;
}
`, "",{"version":3,"sources":["webpack://./../components/src/layouts/ResultsGridLayout/components/SearchImgCardComponent/components/SimilarImagesIconComponent/SimilarImagesIconComponent.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;IACI,+BAA+B;IAC/B,qCAAqC;IACrC,sCAAsC;IACtC,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,wCAAwC;IACxC,0DAA0D;IAC1D,mBAAmB;IACnB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,qDAAqD;IACrD,6CAA6C;AACjD;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;IAC5B,kCAAkC;IAClC,mCAAmC;IACnC,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,sCAAsC;AAC1C","sourcesContent":["/* SimilarImagesIconComponent Styles */\n:host {\n    --img-similar-images-size: 50px;\n    width: var(--img-similar-images-size);\n    height: var(--img-similar-images-size);\n    aspect-ratio: 1 / 1;\n    position: absolute;\n    top: 5px;\n    left: 5px;\n}\n\n.img-similar-images {\n    flex-direction: row;\n    padding: 3px;\n    align-items: center;\n    border-radius: var(--radius-extra-small);\n    background-color: var(--surface-variant-dark-transparency);\n    margin: 3px 0 0 3px;\n    width: 100%;\n    aspect-ratio: 1 / 1;\n}\n\n.img-similar-images:hover {\n    cursor: pointer;\n    background-color: var(--surface-variant-transparency);\n    transition: background-color 0.5s ease-in-out;\n}\n\nimg {\n    object-fit: cover;\n}\n\n[data-similar-tooltip-placeholder] {\n    --similar-tooltip-size: 40px;\n    width: var(--similar-tooltip-size);\n    height: var(--similar-tooltip-size);\n    aspect-ratio: 1 / 1;\n}\n\n[data-similar-tooltip-placeholder]:hover {\n    cursor: pointer;\n    transform: scale(1.05);\n    transition: transform 0.2s ease-in-out;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
